define(
    'views/customized-pdf-view',[
        'jquery',
        'utils/view'
    ],

    function ($, View) {

        function CustomizedPdfView() {}

        /**
         * Init bindings for available images.
         * Select first available image.
         */
        CustomizedPdfView.prototype.init = function() {
            
            var availableImages = $("#coverimageselector img");
            if (availableImages.length > 0)
            {
                availableImages.on("click", function(evt) {
                    $("#coverimageselector img").removeClass("coverimage__selected");
                    $("#coverimage").val(this.src);
                    $(this).toggleClass("coverimage__selected");
                });

                availableImages[0].click();

            } 
        };

        return View("CustomizedPdfView", function() {
            var cfv = new CustomizedPdfView();
            cfv.init();
        });
    }
);
